<app-selection-list
  [heightClass]="itemsHeight"
  [label]="input_label"
  [searchLabel]="input_searchLabel"
  [items]="items"
  [loading]="loading"
  [id]="id"
  [values]="values"
  [optionTitle]="optionTitle"
  [optionValue]="optionValue"
  [sortKey]="sortKey"
  [isReadOnly]="isReadOnly"
  [customSortArray]="customSortArray"
  [isSmallSize]="isSmallSize"
  [isRoleOrganizationForm]="isRoleOrganizationForm"
  [isDisableSelectedItem]="isDisableSelectedItem"
  [responsiveClass]="input_responsiveClass"
  [searchBoxGridClass]="input_searchBoxGridClass"
  [optionCustomClass]="input_optionCustomClass"
  [isRequired]="isRequired"
  [isShowSelectAll]="isShowSelectAll"
  (values)="emitValues($event)"
  (items)="emitItems($event)"
>
</app-selection-list>
